import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

interface IAlertPopup {
  isOpen: boolean;
  toggle: (value: boolean) => void;
  onAction: () => void;
}
const AlertPopup: React.FunctionComponent<IAlertPopup> = ({
  isOpen,
  toggle,
  onAction
}) => {
  return (
    <div>
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>Logout</ModalHeader>
        <ModalBody>Are you sure you want to log out?</ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={onAction}>
            OK
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default AlertPopup;
